import { Button, Form, Input, message } from 'antd';
import { useChangePasswordValidation } from 'api';
import { userforgotpassword, UserPayload } from 'api/profile';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
  onSubmit: (values: UserPayload) => Promise<void>;
};
//const inituser: UserPayload = {};

const ForgottenPassword = ({ onSubmit }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<UserPayload>();
  //const [_user, _setUser] = useState(inituser);
  const [isUsernamevalidated, _setUsernamevalidated] = useState(false);
  const [_isRedirect, setRedirect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // const handleUsernameMatch = useCallback(
  //     async (values: UserPayload) => {
  //
  //         //setUsername(e.target.value);
  //         let forgotuser: UserPayload = {
  //             username: values.userName
  //         }
  //         userforgotpassword(forgotuser).then((_x) => {
  //             if (_x.data.userName != null) {
  //                 message.success('Username Validated!');
  //                 //setUsernamevalidated(true);

  //             }
  //             else {
  //                 //setUsernamevalidated(false)
  //             }
  //         }
  //     }, []
  // );

  const validation = useChangePasswordValidation();
  const handleSubmit = useCallback(
    async (values: UserPayload) => {
      setIsLoading(true);
      userforgotpassword(values).then((_x) => {
        if (_x.data != null) {
          message.success('Username Validated and Password Changed Successfully!');
        }
        form.resetFields();
        onSubmit(_x.data);
      });
      setRedirect(true);

      navigate('/');
      setIsLoading(false);
    },
    [onSubmit, form]
  );

  return (
    <>
      <div className="container" style={{ width: '60%' }}>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className="mid-container">
              <div className="submission-box">
                <h2>Forgot Password</h2>
                {/* <Title level={4}>{t('changePassword.title')}</Title> */}
                <Form<UserPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                >
                  <Form.Item label="UserName" name="userName" validateFirst required>
                    <Input
                      type="email"
                      placeholder="Enter UserName"
                      //value={isUsername}
                      //onSubmit={handleUsernameMatch}
                    />
                  </Form.Item>
                  <>
                    <Form.Item
                      label={t('changePassword.newPassword.label')}
                      name="password"
                      rules={validation.password}
                      validateFirst
                    >
                      <Input.Password
                        placeholder={t('changePassword.newPassword.placeholder')}
                        disabled={isUsernamevalidated ? true : false}
                      />
                    </Form.Item>

                    <Form.Item
                      required
                      label="Confirm Password"
                      name="confirmPassword"
                      className="Confirm Password"
                      rules={validation.password}
                      validateFirst
                    >
                      <Input.Password
                        placeholder="Confirm Password"
                        disabled={isUsernamevalidated ? true : false}
                      />
                    </Form.Item>
                  </>

                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    style={{ float: 'right', marginBottom: '10px' }}
                  >
                    {t('changePassword.submit')}
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgottenPassword;
